import { createContext, useCallback, useContext, useState } from 'react';
import { SoonModal } from './SoonModal';

const SoonModalContext = createContext(null);

export function SoonModalProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openSoonModal = useCallback(() => setOpen(true), []);
  const closeSoonModal = useCallback(() => setOpen(false), []);

  return (
    <SoonModalContext.Provider value={{ openSoonModal }}>
      {children}
      {open ? <SoonModal onClose={closeSoonModal} /> : null}
    </SoonModalContext.Provider>
  );
}

export function useSoonModal() {
  const ctx = useContext(SoonModalContext);
  if (!ctx) {
    throw new Error('useSoonModal must be used within SoonModalProvider');
  }
  return ctx;
}
